import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import LitStructuredText from './generic/LitStructuredText';

const orderJourneyContact = () => {
  const data = query();
  const orderJourneyContactData = data.allDatoCmsOrderJourneyModel.nodes[0];
  return (
    <div className="order-journey-contact-container">
      <div className="order-journey-contact-inner">
        <LitStructuredText
          data={orderJourneyContactData.contactHeading}
          basic
        />
        <LitStructuredText data={orderJourneyContactData.contactText} basic />
        <a
          href={orderJourneyContactData.buttonUrl}
          className="button-blue"
          target="_blank"
        >
          {orderJourneyContactData.buttonText}
        </a>
      </div>
    </div>
  );
};
export default orderJourneyContact;

const query = () =>
  useStaticQuery(graphql`
    {
      allDatoCmsOrderJourneyModel {
        nodes {
          buttonUrl
          buttonText
          buttonColour
          contactHeading {
            value
          }
          contactText {
            value
          }
        }
      }
    }
  `);
